import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {PopupGuard} from './guards/popup.guard';
import {AuthGuard} from './guards/auth-guard';
import {EditGuard} from './guards/edit.guard';

const routes: Routes = [
    {path: '', redirectTo: 'home', pathMatch: 'full'},

    // --- open routes
    {path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)},
    {path: 'logout', loadChildren: () => import('./pages/logout/logout.module').then(m => m.LogoutPageModule)},

    // --- protected by authentication
    {
        path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
        canActivate: [AuthGuard], canDeactivate: [PopupGuard], data: {access: ['SEARCH']}
    },

    // --- protected by authorization
    {
        path: 'deviceSingle',
        loadChildren: () => import('./pages/device-single/device-single.module').then(m => m.DeviceSinglePageModule),
        canActivate: [AuthGuard],
        canDeactivate: [PopupGuard, EditGuard],
        data: {access: ['SEARCH']}
    },
    {
        path: 'search', loadChildren: () => import('./pages/search/search.module').then(m => m.SearchPageModule),
        canActivate: [AuthGuard], canDeactivate: [PopupGuard], data: {access: ['SEARCH']}
    },
    {
        path: 'deviceList',
        loadChildren: () => import('./pages/device-list/device-list.module').then(m => m.DeviceListPageModule),
        canActivate: [AuthGuard],
        canDeactivate: [PopupGuard, EditGuard],
        data: {access: ['SEARCH']}
    },
    {
        path: 'addDevice',
        loadChildren: () => import('./pages/add-device/add-device.module').then(m => m.AddDevicePageModule),
        canActivate: [AuthGuard],
        canDeactivate: [PopupGuard, EditGuard],
        data: {access: ['EDIT']}
    },
    {
        path: 'settings',
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule),
        canActivate: [AuthGuard],
        canDeactivate: [PopupGuard],
        data: {access: ['SEARCH']}
    },
    {
        path: 'admin', loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminPageModule),
        canActivate: [AuthGuard], canDeactivate: [PopupGuard], data: {access: ['ADMIN']}
    },
    // {
    //     path: 'special', loadChildren: () => import('./pages/special/special.module').then(m => m.SpecialPageModule),
    //     canActivate: [AuthGuard], canDeactivate: [PopupGuard], data: {access: ['EDIT_FOREIGN']}
    // },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        onSameUrlNavigation: 'reload'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
